import React from 'react';

import PropTypes from 'prop-types';

import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';

import useUserSubscriptions from './hooks/useUserSubscriptions';
import SubscriptionsModalView from './SubscriptionsModalView';

type SubscriptionsModalProps = StylableComponent<HTMLDivElement> & {
  onCloseModal: () => void;
};
/**
 * A SubscriptionsModal
 * A Subscriptions Modal allows to show messages about subscriptions of the user.
 */

const SubscriptionsModal = React.forwardRef<
  HTMLDivElement,
  SubscriptionsModalProps
>(({ onCloseModal, ...props }, ref) => {
  const { subscriptions, error, isLoading, refetch } = useUserSubscriptions();

  return (
    <SubscriptionsModalView
      onCloseModal={onCloseModal}
      error={error}
      ref={ref}
      subscriptions={subscriptions}
      isLoading={isLoading}
      refetch={refetch}
      {...props}
    />
  );
});

SubscriptionsModal.displayName = 'SubscriptionsModal';

SubscriptionsModal.propTypes = {
  /** Class applied to the root element */
  className: PropTypes.string,
  /** Close modal function */
  onCloseModal: PropTypes.func.isRequired,
  /** Styles applied to the root element */
  style: stylePropType,
};

export default SubscriptionsModal;
